import { render } from "./ClashTestPopup.vue?vue&type=template&id=15498bc1&scoped=true&ts=true"
import script from "./ClashTestPopup.vue?vue&type=script&lang=ts"
export * from "./ClashTestPopup.vue?vue&type=script&lang=ts"

import "./ClashTestPopup.vue?vue&type=style&index=0&id=15498bc1&scoped=true&lang=scss"
import "./ClashTestPopup.vue?vue&type=style&index=1&id=15498bc1&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15498bc1"]])

export default __exports__